import React, { Fragment, useContext, useEffect, useState } from 'react';
import ErrorBoundary from '../ErrorBoundary';
import { connect } from 'react-redux';
import { Button, Dropdown, Modal, Table } from 'react-bootstrap';
import Editor from '@jsx/components/RichTextEditor';
import moment from 'moment';
import { AdminActions } from '@adapters/redux/reducer/admin';
import { ToastNotificationContext } from '@context/ToastNotificationContext';
import PageLoader from '../Loader/PageLoader';

const Page = (props) => {
  const { subscribers, sendEmail, sendingEmail } = props;

  const { notifySuccess, notifyError } = useContext(ToastNotificationContext);

  const [showModal, setShowModal] = useState(false);

  const [subject, setSubject] = useState('');
  const [content, setContent] = useState('');

  const onClickShowModal = () => {
    setSubject('');
    setContent('');
    setShowModal(true);
  };

  const onClickSubmit = () =>
    sendEmail({ subject, content }, (isError, error) => {
      if (isError) {
        notifyError(error);
      } else {
        setShowModal(false);
        notifySuccess('Send email to subscribers successfully');
      }
    });

  return (
    <Fragment>
      <div className="text-right mb-3">
        <button onClick={onClickShowModal} className="btn btn-success">
          Send email to subscribers
        </button>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">List Subscribers</h4>
            </div>
            <div className="card-body">
              <Table responsive>
                <thead>
                  <tr>
                    <th className="width80">
                      <strong>#</strong>
                    </th>
                    <th>
                      <strong>Email</strong>
                    </th>
                    <th>
                      <strong>Subscribe time</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {subscribers?.map((subscriber, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{subscriber.email}</td>
                        <td>
                          {moment(subscriber.createdAt).format(
                            'HH:MM DD/MM/YYYY'
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
      <Modal className="fade" enforceFocus={false} show={showModal} size="lg">
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <Modal.Header>
            <Modal.Title>Send email to subscribers</Modal.Title>
            <Button
              variant=""
              className="btn-close"
              onClick={() => setShowModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            {sendingEmail && <PageLoader />}
            <div className="form-group">
              <label className="form-label">Subject</label>
              <input
                className="form-control"
                type="text"
                id="name"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />
            </div>
            <div className="form-group mt-3">
              <label className="form-label">Email content</label>
              <Editor value={content} onChange={setContent} />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger light" onClick={() => setShowModal(false)}>
              Close
            </Button>
            <Button
              variant=""
              type="button"
              className="btn btn-primary"
              onClick={onClickSubmit}
            >
              Send
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  subscribers: state.admin.subscribers,
  sendingEmail: state.admin.sendingEmail,
});

const mapDispatchToProps = (dispatch) => ({
  sendEmail: (params, callback) =>
    dispatch(AdminActions.sendEmail(params, callback)),
});

const withErrorBoundary = (props) => (
  <ErrorBoundary>
    <Page {...props} />
  </ErrorBoundary>
);

export default connect(mapStateToProps, mapDispatchToProps)(withErrorBoundary);
